import API from "../BaseURL";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


export async function getAllPoints() {
    const res = API.get(`/points/`, configJson);
    return res;
}



export async function getPointsByValve(valve_id) {
  const res = API.get(`/points/valve/${valve_id}`, configJson);
  return res;
}



export async function getPointInfo(point_id) {
    const res = API.get(`/points/${point_id}`, configJson);
    return res;
}


export async function createPoint(data) {
    const res = API.post(`/points/`, data, configJson);
    return res;
}


export async function updatePoint(point_id, data) {
    const res = API.put(`/points/${point_id}/`, data, configJson);
    return res;
}



export async function deletePoint(point_id) {
    const res = API.delete(`/points/${point_id}/`, configJson);
    return res;
}


export async function getPointsByExploitation(exploitation_id) {
    const res = API.get(`/points/exploitation/${exploitation_id}`, configJson);
    return res;
}


export async function getPointsByExploitationAndValve(exploitation_id) {
    const res = API.get(`/points/exploitation/${exploitation_id}/valve`, configJson);
    return res;
}


export async function getPointAudits(point_id) {
    const res = API.get(`/audits/${point_id}`, configJson);
    return (await res).data;
}